import { nip19 } from "nostr-tools";
import { getPubkeyFromDecodeResult, isHexKey } from "applesauce-core/helpers";
import { isSafeRelayURL } from "applesauce-core/helpers/relays";

export function safeDecode(str: string) {
  try {
    const result = nip19.decode(str);
    if ((result.type === "nevent" || result.type === "nprofile" || result.type === "naddr") && result.data.relays)
      result.data.relays = result.data.relays.filter(isSafeRelayURL);
    return result;
  } catch {
    // Not a decodable nip19 string; normalizeToHexPubkey treats a falsy result as "not decodable"
    return undefined;
  }
}

/** Returns the event id or pointer a decoded note, nevent or naddr refers to */
export function getDecodedEventPointer(decoded: nip19.DecodedResult) {
  switch (decoded.type) {
    case "note":
      return decoded.data;
    case "nevent":
      return decoded.data;
    case "naddr":
      return decoded.data;
    default:
      return undefined;
  }
}

export function normalizeToHexPubkey(hex: string) {
  if (isHexKey(hex)) return hex;
  const decode = safeDecode(hex);
  if (!decode) return null;
  return getPubkeyFromDecodeResult(decode) ?? null;
}
